import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type BindInviteCodeReq = {
  invitedCode: Scalars['String']['input'];
};

export type BindTgIdReq = {
  tgUserInfoStr: Scalars['String']['input'];
};

export type BooleanResponse = {
  data?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type ChatRequest = {
  text: Scalars['String']['input'];
};

export type ChatResult = {
  text?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ChatResultResponse = {
  data?: Maybe<Array<Maybe<ChatResult>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type ClaimRequest = {
  app: Scalars['String']['input'];
  bizId?: InputMaybe<Scalars['String']['input']>;
  bizType?: InputMaybe<Scalars['String']['input']>;
  /**  style id */
  templateCode: Scalars['String']['input'];
};

export type CommonPageDto = {
  pageNum?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['String']['output']>;
};

export type ContractConfig = {
  configContract?: Maybe<Scalars['String']['output']>;
  launchPadAirdrop?: Maybe<Scalars['String']['output']>;
  launchPadFactory?: Maybe<Scalars['String']['output']>;
  launchPadHelper?: Maybe<Scalars['String']['output']>;
};

export type ContractConfigResponse = {
  data?: Maybe<ContractConfig>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type FriendTaskPagination = {
  items?: Maybe<Array<Maybe<FriendTaskStatus>>>;
  pagination?: Maybe<CommonPageDto>;
};

export type FriendTaskStatus = {
  address?: Maybe<Scalars['String']['output']>;
  inWhiteList?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type FriendTaskStatusPageList = {
  data?: Maybe<FriendTaskPagination>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type FriendsTaskStatusPageQueryRequest = {
  page: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
};

export type InvestmentDetailResponse = {
  data?: Maybe<InvestmentVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type InvestmentListResponse = {
  data?: Maybe<Array<Maybe<InvestmentVo>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type InvestmentVo = {
  allocation?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issue?: Maybe<IssueSimple>;
  issueAddress?: Maybe<Scalars['String']['output']>;
  issueName?: Maybe<Scalars['String']['output']>;
  issueStatus?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tokenAddress?: Maybe<Scalars['String']['output']>;
  tokenName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type InvitingUserQualifiedResponse = {
  data?: Maybe<InvitingUserQualifiedResponseVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type InvitingUserQualifiedResponseVo = {
  qualifiedCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
};

export type IssueDetailResponse = {
  data?: Maybe<IssueVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type IssueExtra = {
  bannerImg?: Maybe<Scalars['String']['output']>;
  discordUrl?: Maybe<Scalars['String']['output']>;
  iconImg?: Maybe<Scalars['String']['output']>;
  tgUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  webSite?: Maybe<Scalars['String']['output']>;
};

export type IssueListQueryReq = {
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type IssueListResponse = {
  data?: Maybe<Array<Maybe<IssueVo>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type IssueSimple = {
  status?: Maybe<Scalars['String']['output']>;
  stopped?: Maybe<Scalars['Boolean']['output']>;
};

export type IssueVo = {
  address?: Maybe<Scalars['String']['output']>;
  bannerImg?: Maybe<Scalars['String']['output']>;
  createTimestamp?: Maybe<Scalars['String']['output']>;
  depositStartTime?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<IssueExtra>;
  feeRate?: Maybe<Scalars['String']['output']>;
  hasFeeCharged?: Maybe<Scalars['Boolean']['output']>;
  iconImg?: Maybe<Scalars['String']['output']>;
  issueToken?: Maybe<Scalars['String']['output']>;
  issueTokenName?: Maybe<Scalars['String']['output']>;
  issuedTokenAmount?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  launchTime?: Maybe<Scalars['String']['output']>;
  maxDeposit?: Maybe<Scalars['String']['output']>;
  minDeposit?: Maybe<Scalars['String']['output']>;
  needAutoDistribution?: Maybe<Scalars['Boolean']['output']>;
  participantsSize?: Maybe<Scalars['String']['output']>;
  paymentNative?: Maybe<Scalars['Boolean']['output']>;
  paymentToken?: Maybe<Scalars['String']['output']>;
  paymentTokenReserve?: Maybe<Scalars['String']['output']>;
  paymentTokenReserveWithoutFee?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  soldOut?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopped?: Maybe<Scalars['Boolean']['output']>;
  storageIssuedTokenAmount?: Maybe<Scalars['String']['output']>;
  targetRaised?: Maybe<Scalars['String']['output']>;
  targetRaisedWithFee?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['String']['output']>;
};

export type LoginReq = {
  /**  is public */
  ethAddress: Scalars['String']['input'];
  invitedCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  style id */
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResult = {
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LoginResultResponse = {
  data?: Maybe<LoginResult>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  bindInvitedCode?: Maybe<BooleanResponse>;
  bindTgId?: Maybe<BooleanResponse>;
  chatWithAI?: Maybe<ChatResultResponse>;
  claim?: Maybe<BooleanResponse>;
  login?: Maybe<LoginResultResponse>;
  loginAndVerify?: Maybe<LoginResultResponse>;
  updateUserById?: Maybe<BooleanResponse>;
};


export type MutationBindInvitedCodeArgs = {
  req: BindInviteCodeReq;
};


export type MutationBindTgIdArgs = {
  req: BindTgIdReq;
};


export type MutationChatWithAiArgs = {
  req: ChatRequest;
};


export type MutationClaimArgs = {
  req: ClaimRequest;
};


export type MutationLoginArgs = {
  req: LoginReq;
};


export type MutationLoginAndVerifyArgs = {
  req: LoginReq;
};


export type MutationUpdateUserByIdArgs = {
  req: UserUpdateReq;
};

export type QualifiedFriendsQueryRequest = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  friendTaskStatusList?: Maybe<FriendTaskStatusPageList>;
  friendTasksRank?: Maybe<RankResponse>;
  getContractConfig?: Maybe<ContractConfigResponse>;
  getIssueDetail?: Maybe<IssueDetailResponse>;
  getIssueList?: Maybe<IssueListResponse>;
  getNonce?: Maybe<StringResponse>;
  getQualifiedFriends?: Maybe<InvitingUserQualifiedResponse>;
  getUserDetail?: Maybe<UserVoResponse>;
  getUserInvests?: Maybe<InvestmentListResponse>;
  getUserIssueInvest?: Maybe<InvestmentDetailResponse>;
  getUserTaskRecords?: Maybe<TaskRecordListResponse>;
  getUserTaskTemplatesUse?: Maybe<TaskTemplateUseListResponse>;
  isInWhiteList?: Maybe<BooleanResponse>;
};


export type QueryFriendTaskStatusListArgs = {
  req?: InputMaybe<FriendsTaskStatusPageQueryRequest>;
};


export type QueryGetIssueDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIssueListArgs = {
  req?: InputMaybe<IssueListQueryReq>;
};


export type QueryGetNonceArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetQualifiedFriendsArgs = {
  req?: InputMaybe<QualifiedFriendsQueryRequest>;
};


export type QueryGetUserDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUserIssueInvestArgs = {
  issue: Scalars['String']['input'];
};


export type QueryGetUserTaskRecordsArgs = {
  req: TaskQueryRequest;
};


export type QueryGetUserTaskTemplatesUseArgs = {
  req: TaskQueryRequest;
};


export type QueryIsInWhiteListArgs = {
  userId: Scalars['String']['input'];
};

export type RankResponse = {
  data?: Maybe<Array<Maybe<RankVo>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type RankVo = {
  cnt?: Maybe<Scalars['String']['output']>;
  ethAddress?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoreInfo = {
  bizId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type StringResponse = {
  data?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskRecord = {
  app?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  innerUser?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  scoreInfo?: Maybe<Array<Maybe<ScoreInfo>>>;
  status?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskNo?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TaskRecordListResponse = {
  data?: Maybe<Array<Maybe<TaskRecord>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateContent = {
  dailyTimesLimit?: Maybe<Scalars['Int']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  twitterName?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateContext = {
  logo?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateUse = {
  content?: Maybe<TaskTemplateContent>;
  context?: Maybe<TaskTemplateContext>;
  desc?: Maybe<Scalars['String']['output']>;
  taskCount?: Maybe<Scalars['String']['output']>;
  taskFinishCount?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateUseListResponse = {
  data?: Maybe<Array<Maybe<TaskTemplateUse>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type UserContent = {
  avatar?: Maybe<Scalars['String']['output']>;
  invitedByCode?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
};

export type UserContentInput = {
  avatar: Scalars['String']['input'];
  nickName: Scalars['String']['input'];
};

export type UserScoreInfo = {
  commonScore?: Maybe<Scalars['String']['output']>;
};

export type UserUpdateReq = {
  content?: InputMaybe<UserContentInput>;
  name: Scalars['String']['input'];
};

export type UserVo = {
  content?: Maybe<UserContent>;
  ethAddress?: Maybe<Scalars['String']['output']>;
  /**  user id */
  id?: Maybe<Scalars['String']['output']>;
  inviteScore?: Maybe<Scalars['String']['output']>;
  invitedCode?: Maybe<Scalars['String']['output']>;
  invitesCount?: Maybe<Scalars['String']['output']>;
  /**  user name */
  name?: Maybe<Scalars['String']['output']>;
  scoreInfo?: Maybe<UserScoreInfo>;
  /**  user status */
  status?: Maybe<Scalars['String']['output']>;
  tgId?: Maybe<Scalars['String']['output']>;
  xId?: Maybe<Scalars['String']['output']>;
};

export type UserVoResponse = {
  data?: Maybe<UserVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskQueryRequest = {
  appToken?: InputMaybe<Scalars['String']['input']>;
  taskNos?: InputMaybe<Array<Scalars['String']['input']>>;
  templateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetNonceQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetNonceQuery = { getNonce?: { data?: string } };

export type GetUserDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserDetailQuery = { getUserDetail?: { success?: boolean, traceId?: string, data?: { invitedCode?: string, ethAddress?: string, id?: string, invitesCount?: string, name?: string, tgId?: string, xId?: string, status?: string, inviteScore?: string, content?: { avatar?: string, invitedByCode?: string, nickName?: string }, scoreInfo?: { commonScore?: string } } } };

export type LoginMutationVariables = Exact<{
  req: LoginReq;
}>;


export type LoginMutation = { login?: { data?: { userId?: string, token?: string } } };


export const GetNonceDocument = gql`
    query getNonce($address: String!) {
  getNonce(address: $address) {
    data
  }
}
    `;
export const GetUserDetailDocument = gql`
    query getUserDetail($id: String!) {
  getUserDetail(id: $id) {
    data {
      content {
        avatar
        invitedByCode
        nickName
      }
      invitedCode
      ethAddress
      id
      invitesCount
      name
      scoreInfo {
        commonScore
      }
      tgId
      xId
      status
      inviteScore
    }
    success
    traceId
  }
}
    `;
export const LoginDocument = gql`
    mutation login($req: LoginReq!) {
  login(req: $req) {
    data {
      userId
      token
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getNonce(variables: GetNonceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetNonceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNonceQuery>({ document: GetNonceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getNonce', 'query', variables);
    },
    getUserDetail(variables: GetUserDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserDetailQuery>({ document: GetUserDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUserDetail', 'query', variables);
    },
    login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>({ document: LoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'login', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;